import { ClassAttributes, FC, HTMLAttributes } from 'react';
import { ExtraProps } from 'react-markdown';

type Props = ClassAttributes<HTMLAnchorElement> &
  HTMLAttributes<HTMLAnchorElement> &
  ExtraProps & { href?: string };

const AnchorTag: FC<Props> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { node, children, href = '', ...rest } = props;

  const samePage = String(href).startsWith('#');

  const anchorProps = {
    ...rest,
    href,
    target: samePage ? '_self' : '_blank',
  };

  return <a {...anchorProps}>{children}</a>;
};

export default AnchorTag;
